// Boot-time singletons: the runtime config, the login and the generated API client.
import type { Api } from './api/client';
import type { TokenSource } from './auth/oidc';
import type { Config } from './config';

export interface AppContext {
  cfg: Config;
  auth: TokenSource & { logout(): Promise<void> };
  api: Api;
}

let ctx: AppContext | undefined;
export function setContext(c: AppContext): void {
  ctx = c;
}
export function useContext(): AppContext {
  if (!ctx) throw new Error('app context not initialised');
  return ctx;
}
